import { render } from "./SavedTablesDeleteDialog.vue?vue&type=template&id=5ac78201"
import script from "./SavedTablesDeleteDialog.vue?vue&type=script&lang=js"
export * from "./SavedTablesDeleteDialog.vue?vue&type=script&lang=js"

import "./SavedTablesDeleteDialog.vue?vue&type=style&index=0&id=5ac78201&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog});qInstall(script, 'directives', {ClosePopup});
